e4.handlebars = {
    tmpl: {},
    registerTemplates: function ( strTemplates ) {
        var arrTemplates = strTemplates.split( ' ' );
        for ( var i = 0; i < arrTemplates.length; i++ ) {
            if ( jQuery( arrTemplates[ i ] ).length === 1 ) {
                var tmplName = arrTemplates[ i ].replace( '#js-e-handlebars-tmpl-', '' ).replace( /-([a-z])/g, function ( strMatch ) {
                    return strMatch[ 1 ].toUpperCase();
                } );
                e4.handlebars.tmpl[ tmplName ] = Handlebars.compile( jQuery( arrTemplates[ i ] ).html() );
            }
        }
    },
    partial: {},
    registerPartials: function ( strPartials ) {
        var arrPartials = strPartials.split( ' ' );
        for ( var i = 0; i < arrPartials.length; i++ ) {
            if ( jQuery( arrPartials[ i ] ).length === 1 ) {
                var partialName = arrPartials[ i ].replace( '#js-e-handlebars-partial-', '' ).replace( /-([a-z])/g, function ( strMatch ) {
                    return strMatch[ 1 ].toUpperCase();
                } );
                Handlebars.registerPartial( partialName, jQuery( arrPartials[ i ] ).html() );
                e4.handlebars.partial[ partialName ] = Handlebars.compile( jQuery( arrPartials[ i ] ).html() );
            }
        }
    },
    registerHelpers: function ( strHelpers ) {
        var arrHelpers = strHelpers.split( ' ' );
        for ( var i = 0; i < arrHelpers.length; i++ ) {
            if ( window.Handlebars.helpers[ arrHelpers[ i ] ] === undefined ) {
                e4.handlebars.helpers[ arrHelpers[ i ] ]();
            }
        }
    },
    helpers: {
        testValue: function ( v1, operator, v2 ) {
            switch ( operator ) {
                case '===':
                    return ( v1 === v2 );
                case '!==':
                    return ( v1 !== v2 );
                case '<':
                    return ( v1 < v2 );
                case '<=':
                    return ( v1 <= v2 );
                case '>':
                    return ( v1 > v2 );
                case '>=':
                    return ( v1 >= v2 );
                case '&&':
                    return ( v1 && v2 );
                case '||':
                    return ( v1 || v2 );
                case '!!':
                    return ( !v1 && !v2 );
                case '!|':
                    return ( !v1 && v2 );
                case '|!':
                    return ( v1 && !v2 );
                default:
                    return false;
            }
        },
        compare_extended: function () {
            Handlebars.registerHelper( 'compare_extended', function ( v1, operator, v2, options ) {
                if ( v2.indexOf( ',' ) > -1 ) {
                    // v2 is array - extend compare-function
                    var v2Arr       = v2.split( ',' ),
                        v2ReturnArr = [];
                    // iterate v2-array and test each value, adding the returned boolean to a temp array
                    for ( var i = 0; i < v2Arr.length; i++ ) {
                        v2ReturnArr.push( e4.handlebars.helpers.testValue( v1, operator, v2Arr[ i ] ) );
                    }
                    // test temp array values, returning true if all values are the same, eg. [true,true] or
                    // [false,false]
                    return v2ReturnArr.every( function ( val ) {
                        return val
                    } ) === true ? options.fn( this ) : options.inverse( this );
                }
                else {
                    // v2 is string - standard compare function
                    return e4.handlebars.helpers.testValue( v1, operator, v2 ) ? options.fn( this ) : options.inverse( this );
                }
            } );
        },
        compare: function () {
            Handlebars.registerHelper( 'compare', function ( v1, operator, v2, options ) {
                switch ( operator ) {
                case '===':
                    return ( v1 === v2 ) ? options.fn( this ) : options.inverse( this );
                case '!==':
                    return ( v1 !== v2 ) ? options.fn( this ) : options.inverse( this );
                case '<':
                    return ( v1 < v2 ) ? options.fn( this ) : options.inverse( this );
                case '<=':
                    return ( v1 <= v2 ) ? options.fn( this ) : options.inverse( this );
                case '>':
                    return ( v1 > v2 ) ? options.fn( this ) : options.inverse( this );
                case '>=':
                    return ( v1 >= v2 ) ? options.fn( this ) : options.inverse( this );
                case '&&':
                    return ( v1 && v2 ) ? options.fn( this ) : options.inverse( this );
                case '||':
                    return ( v1 || v2 ) ? options.fn( this ) : options.inverse( this );
                case '!!':
                    return ( !v1 && !v2 ) ? options.fn( this ) : options.inverse( this );
                case '!|':
                    return ( !v1 && v2 ) ? options.fn( this ) : options.inverse( this );
                case '|!':
                    return ( v1 && !v2 ) ? options.fn( this ) : options.inverse( this );
                default:
                    return options.inverse( this );
                }
            } );
        },
        counter: function () {
            Handlebars.registerHelper( 'counter', function ( index ) {
                return index + 1;
            } );
        },
        facet_group: function(){
            Handlebars.registerHelper( 'facet_group', function ( nointeraction, index, maxIndex, options ) {
                var arr = [nointeraction, (index < maxIndex)];
                return arr.every( function ( val ) {
                    return val
                } ) === true ? options.fn( this ) : options.inverse( this );
            } );
        },
        replace_in_str: function(){
            Handlebars.registerHelper( 'replace_in_str', function ( str, find, replace, options) {
                return str.replace( find, replace );
            } );
        }
    }
};

